// Import react-circular-progressbar module and styles

export default function PaymentSuccess() {
  return (
    <div className="min-h-screen flex flex-col pb-[95px] max-w-md mx-auto bg-[#F5F5F5]">
      {/* Success Message Section */}
      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <svg
            className="w-10 h-10 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-center mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-600 text-center mb-8">
          Thank you for your payment. Your transaction has been completed.
        </p>
        <button
          onClick={() => (window.location.href = "/login")}
          className="bg-[#F0A7D6] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#e391c4] transition-colors"
        >
          Login
        </button>
      </div>

      {/* <BottomNavbar /> */}
    </div>
  );
}
